// assets/nd-cart-shipping-fields.js
// Clean version after cart.js fix
// Address Book (dropdown + Save/Delete) + Shipping block + Clear Shipping button
// Supports optional saving/loading of Reference Number

(function () {
  if (window.__ND_CART_SHIPPING_FIELDS_NEW_SITE_CLEAN_V1__) return;
  window.__ND_CART_SHIPPING_FIELDS_NEW_SITE_CLEAN_V1__ = true;

  // ---------- UI font sizes ----------
  var TITLE_FONT_SIZE = "inherit";
  var LABEL_FONT_SIZE = "1.4rem";
  var INPUT_FONT_SIZE = "1.4rem";

  // ---------- Address Book API config ----------
  var ADDRESS_API_URL = "https://script.google.com/macros/s/AKfycbwZHpkNRhTdS6ol2CBuuUSZLQPSIFIsocoowgLrWnYhFW6zq4dfyRkYlxYGduuAffjx/exec";
  var ADDRESS_API_KEY = "MPQuoteAddressBook";

  // ---------- Google Address Autocomplete config ----------
var GOOGLE_MAPS_API_KEY = "AIzaSyD8UXmMmaLAnplNsWMyMHiM_kKaHHw2F_g";
var GOOGLE_MAPS_SCRIPT_ID = "nd-google-maps-places-js";

  // false = 跟舊站一樣，不存/不讀取 Reference Number
  // true  = Save Address / Load Address 都包含 Reference Number
  var SAVE_REFERENCE_NUMBER_TO_ADDRESS_BOOK = false;
    var US_STATES = [
    ["AL", "Alabama"],
    ["AK", "Alaska"],
    ["AZ", "Arizona"],
    ["AR", "Arkansas"],
    ["CA", "California"],
    ["CO", "Colorado"],
    ["CT", "Connecticut"],
    ["DE", "Delaware"],
    ["FL", "Florida"],
    ["GA", "Georgia"],
    ["HI", "Hawaii"],
    ["ID", "Idaho"],
    ["IL", "Illinois"],
    ["IN", "Indiana"],
    ["IA", "Iowa"],
    ["KS", "Kansas"],
    ["KY", "Kentucky"],
    ["LA", "Louisiana"],
    ["ME", "Maine"],
    ["MD", "Maryland"],
    ["MA", "Massachusetts"],
    ["MI", "Michigan"],
    ["MN", "Minnesota"],
    ["MS", "Mississippi"],
    ["MO", "Missouri"],
    ["MT", "Montana"],
    ["NE", "Nebraska"],
    ["NV", "Nevada"],
    ["NH", "New Hampshire"],
    ["NJ", "New Jersey"],
    ["NM", "New Mexico"],
    ["NY", "New York"],
    ["NC", "North Carolina"],
    ["ND", "North Dakota"],
    ["OH", "Ohio"],
    ["OK", "Oklahoma"],
    ["OR", "Oregon"],
    ["PA", "Pennsylvania"],
    ["RI", "Rhode Island"],
    ["SC", "South Carolina"],
    ["SD", "South Dakota"],
    ["TN", "Tennessee"],
    ["TX", "Texas"],
    ["UT", "Utah"],
    ["VT", "Vermont"],
    ["VA", "Virginia"],
    ["WA", "Washington"],
    ["WV", "West Virginia"],
    ["WI", "Wisconsin"],
    ["WY", "Wyoming"]
  ];

  function buildStateOptions(selected) {
    selected = String(selected || "").toUpperCase();

    var html = '<option value="">-- Select State --</option>';

    US_STATES.forEach(function (st) {
      var code = st[0];
      var name = st[1];
      html +=
        '<option value="' +
        esc(code) +
        '"' +
        (selected === code ? " selected" : "") +
        ">" +
        esc(code + " - " + name) +
        "</option>";
    });

    return html;
  }

  // ---------- Helpers ----------

  function getCartForm() {
    return (
      document.querySelector('form[action="/cart"]') ||
      document.querySelector('form[action*="/cart"]')
    );
  }

  function getCustomerEmail() {
  var body = document.body || document.querySelector("body");
  if (!body) return "";

  var ds = body.dataset || {};

  return String(
    ds.customerEmail ||
    body.getAttribute("data-customer-email") ||
    window.__CUSTOMER_EMAIL__ ||
    window.MPQ_CUSTOMER_EMAIL ||
    window.__MPQ_CUSTOMER_EMAIL__ ||
    ""
  ).toLowerCase().trim();
}

  function esc(v) {
    return v
      ? String(v)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
      : "";
  }

  function fetchJSON(params) {
    var query = Object.keys(params)
      .map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(params[k] == null ? "" : params[k]);
      })
      .join("&");

    var url = ADDRESS_API_URL + "?" + query;

    return fetch(url, {
      method: "GET",
      credentials: "omit",
      redirect: "follow"
    }).then(function (res) {
      return res.json();
    });
  }

  function getCartAttrs() {
  return (window.Shopify && Shopify.cart && Shopify.cart.attributes) || {};
}

async function fetchFreshCartAttrs() {
  try {
    var res = await fetch("/cart.js", {
      method: "GET",
      headers: { "Accept": "application/json" },
      credentials: "same-origin",
      cache: "no-store"
    });

    if (!res.ok) return getCartAttrs();

    var cart = await res.json();
    return (cart && cart.attributes) || {};
  } catch (err) {
    console.warn("[ND Shipping] failed to fetch fresh cart attrs", err);
    return getCartAttrs();
  }
}

  function saveCartAttributes(attrs) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (res) {
      return res.json();
    });
  }

  function removeDuplicateShippingBlocks() {
  var nodes = document.querySelectorAll('#nd-cart-shipping-fields');
  if (!nodes || !nodes.length) return;

  nodes.forEach(function (node, idx) {
    if (idx > 0 && node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}

function getMainCartHost() {
  return (
    document.getElementById('main-cart-items') ||
    document.querySelector('#main-cart-items') ||
    document.querySelector('cart-items') ||
    document.querySelector('main .page-width') ||
    getCartForm()
  );
}

  // ---------- Build Address Book row + Shipping block ----------

  function buildAddressBookAndShippingBlock(freshAttrs) {
  var attrs = freshAttrs || getCartAttrs();

    var inputStyle =
      "width:100%;" +
      "margin-bottom:10px;" +
      "border-radius:6px;" +
      "border:0.8px solid rgb(153,153,153);" +
      "padding:8px 10px;" +
      "font-size:" + INPUT_FONT_SIZE + ";" +
      "box-shadow:none;" +
      "background-color:transparent;";

    var textareaStyle =
      "width:100%;" +
      "margin-bottom:10px;" +
      "border-radius:6px;" +
      "border:0.8px solid rgb(153,153,153);" +
      "padding:8px 10px;" +
      "font-size:" + INPUT_FONT_SIZE + ";" +
      "box-shadow:none;" +
      "background-color:transparent;" +
      "resize:vertical;";

          var selectStyle =
      "width:100%;" +
      "margin-bottom:10px;" +
      "border-radius:6px;" +
      "border:0.8px solid rgb(153,153,153);" +
      "padding:8px 10px;" +
      "font-size:" + INPUT_FONT_SIZE + ";" +
      "box-shadow:none;" +
      "background-color:transparent;";

      var hiddenStyle = "display:none;";

    var container = document.createElement("div");
    container.id = "nd-cart-shipping-fields";
    container.style.maxWidth = "720px";
    container.style.margin = "24px auto 24px";
    container.style.boxSizing = "border-box";
    container.style.fontFamily = "inherit";
    container.style.color = "inherit";
    container.style.fontSize = "inherit";

    container.innerHTML =
      '<div id="nd-address-book-block" style="margin-bottom:22px;">' +
      '  <div style="display:flex;flex-wrap:wrap;align-items:flex-end;gap:16px;">' +
      '    <div style="flex:1 1 260px;min-width:260px;">' +
      '      <label style="display:block;margin-bottom:4px;font-size:' +
      TITLE_FONT_SIZE +
      ';font-weight:600;">Address Book</label>' +
      '      <select id="nd-ab-select" style="width:100%;padding:8px 10px;border-radius:6px;border:0.8px solid rgb(153,153,153);font-size:' +
      INPUT_FONT_SIZE +
      ';background-color:transparent;">' +
      '        <option value="">-- Select saved info --</option>' +
      "      </select>" +
      "    </div>" +
      '    <div style="display:flex;flex-wrap:wrap;gap:8px;">' +
      '      <button type="button" id="nd-ab-save" style="padding:8px 14px;border-radius:6px;border:0.8px solid rgb(153,153,153);background:transparent;cursor:pointer;font-size:' +
      INPUT_FONT_SIZE +
      ';">Save Address</button>' +
      '      <button type="button" id="nd-ab-delete" style="padding:8px 14px;border-radius:6px;border:0.8px solid rgb(153,153,153);background:transparent;cursor:pointer;font-size:' +
      INPUT_FONT_SIZE +
      ';">Delete Address</button>' +
      '      <button type="button" id="nd-ab-clear" style="padding:8px 14px;border-radius:6px;border:0.8px solid rgb(153,153,153);background:transparent;cursor:pointer;font-size:' +
      INPUT_FONT_SIZE +
      ';">Clear Shipping Info</button>' +
      "    </div>" +
      "  </div>" +
      '  <div id="nd-ab-msg" style="margin-top:6px;font-size:0.8rem;color:#666;"></div>' +
      "</div>" +

      '<h3 style="margin:0 0 10px 0;font-size:' +
      TITLE_FONT_SIZE +
      ';font-weight:600;font-family:inherit;">Shipping Information</h3>' +

      '<div style="display:flex;flex-wrap:wrap;gap:16px;margin-bottom:6px;">' +
      '  <div style="flex:1 1 0;min-width:160px;">' +
      '    <label style="display:block;margin-bottom:4px;font-size:' +
      LABEL_FONT_SIZE +
      ';">Contact Name</label>' +
      '    <input type="text" name="attributes[Shipping Contact Name]" style="' +
      inputStyle + '" value="' + esc(attrs["Shipping Contact Name"]) + '">' +
      "  </div>" +
      '  <div style="flex:1 1 0;min-width:160px;">' +
      '    <label style="display:block;margin-bottom:4px;font-size:' +
      LABEL_FONT_SIZE +
      ';">Phone Number</label>' +
      '    <input type="text" name="attributes[Shipping Phone]" style="' +
      inputStyle + '" value="' + esc(attrs["Shipping Phone"]) + '">' +
      "  </div>" +
      '  <div style="flex:1 1 0;min-width:160px;">' +
      '    <label style="display:block;margin-bottom:4px;font-size:' +
      LABEL_FONT_SIZE +
      ';">Reference Number</label>' +
      '    <input type="text" name="attributes[Reference Number]" style="' +
      inputStyle + '" value="' + esc(attrs["Reference Number"]) + '">' +
      "  </div>" +
      "</div>" +

      '<label style="display:block;margin-bottom:4px;font-size:' +
      LABEL_FONT_SIZE +
      ';">Company Name (optional)</label>' +
      '<input type="text" name="attributes[Company Name]" style="' +
      inputStyle + '" value="' + esc(attrs["Company Name"]) + '">' +

      '<label style="display:block;margin-bottom:4px;font-size:' +
LABEL_FONT_SIZE +
';">Shipping Address Search</label>' +
'<input id="nd-google-address-search" type="text" autocomplete="off" placeholder="Start typing shipping address..." style="' +
inputStyle + '" value="' + esc(attrs["Shipping Address Search"]) + '">' +

'<label style="display:block;margin-bottom:4px;font-size:' +
LABEL_FONT_SIZE +
';">Street Address</label>' +
'<input type="text" name="attributes[Shipping Address 1]" style="' +
inputStyle + '" value="' + esc(attrs["Shipping Address 1"] || attrs["Shipping Address"]) + '">' +

'<label style="display:block;margin-bottom:4px;font-size:' +
LABEL_FONT_SIZE +
';">Address Line 2 (optional)</label>' +
'<input type="text" name="attributes[Shipping Address 2]" placeholder="Suite / Unit / Dock / Attention" style="' +
inputStyle + '" value="' + esc(attrs["Shipping Address 2"]) + '">' +

'<div style="display:flex;flex-wrap:wrap;gap:16px;align-items:flex-start;">' +

'  <div style="flex:2 1 220px;min-width:180px;">' +
'    <label style="display:block;margin-bottom:4px;font-size:' +
LABEL_FONT_SIZE +
';">City</label>' +
'    <input type="text" name="attributes[Shipping City]" style="' +
inputStyle + '" value="' + esc(attrs["Shipping City"]) + '">' +
'  </div>' +

'  <div style="flex:1 1 180px;min-width:160px;">' +
'    <label style="display:block;margin-bottom:4px;font-size:' +
LABEL_FONT_SIZE +
';">State</label>' +
'    <select name="attributes[Shipping State]" style="' +
selectStyle +
'">' +
buildStateOptions(attrs["Shipping State"] || attrs["State"] || attrs["shipping_state"]) +
'</select>' +
'  </div>' +

'  <div style="flex:1 1 160px;min-width:140px;">' +
'    <label style="display:block;margin-bottom:4px;font-size:' +
LABEL_FONT_SIZE +
';">ZIP Code</label>' +
'    <input type="text" name="attributes[Shipping ZIP]" style="' +
inputStyle + '" value="' + esc(attrs["Shipping ZIP"]) + '">' +
'  </div>' +

'</div>' +

'<label style="display:block;margin-bottom:4px;font-size:' +
LABEL_FONT_SIZE +
';">Country</label>' +
'<input type="text" name="attributes[Shipping Country]" style="' +
inputStyle + '" value="' + esc(attrs["Shipping Country"] || "United States") + '">' +

'<input type="hidden" name="attributes[Google Place ID]" style="' +
hiddenStyle +
'" value="' + esc(attrs["Google Place ID"]) + '">' +

'<textarea name="attributes[Shipping Address]" rows="2" style="display:none;">' +
esc(attrs["Shipping Address"]) +
'</textarea>';

    return container;
  }

  // ---------- Address Book wiring ----------

  function setupAddressBook(root) {
    if (!root) return;

    var customerEmail = getCustomerEmail();
    var apiUrl = ADDRESS_API_URL;
    var apiKey = ADDRESS_API_KEY;

    var selectEl  = root.querySelector("#nd-ab-select");
    var btnSave   = root.querySelector("#nd-ab-save");
    var btnDelete = root.querySelector("#nd-ab-delete");
    var btnClear  = root.querySelector("#nd-ab-clear");
    var msgEl     = root.querySelector("#nd-ab-msg");

    if (!selectEl || !btnSave || !btnDelete || !btnClear || !msgEl) {
      console.warn("[ND AB] required elements not found, abort.");
      return;
    }

    var itemsCache = [];
    var syncTimer = null;

    function setMsg(text, isError) {
      msgEl.textContent = text || "";
      msgEl.style.color = isError ? "#b00020" : "#666";
    }

    function buildFullShippingAddress(v) {
  var cityStateZip = [
    v.shipping_city,
    v.shipping_state,
    v.shipping_zip
  ].filter(Boolean).join(", ");

  return [
    v.shipping_address_1,
    v.shipping_address_2,
    cityStateZip,
    v.shipping_country
  ].filter(Boolean).join("\n");
}

    function getFieldValues() {
  var fContact = root.querySelector('input[name="attributes[Shipping Contact Name]"]');
  var fPhone   = root.querySelector('input[name="attributes[Shipping Phone]"]');
  var fRef     = root.querySelector('input[name="attributes[Reference Number]"]');
  var fCompany = root.querySelector('input[name="attributes[Company Name]"]');

  var fSearch  = root.querySelector('#nd-google-address-search');
  var fAddr1   = root.querySelector('input[name="attributes[Shipping Address 1]"]');
  var fAddr2   = root.querySelector('input[name="attributes[Shipping Address 2]"]');
  var fCity    = root.querySelector('input[name="attributes[Shipping City]"]');
  var fState   = root.querySelector('select[name="attributes[Shipping State]"]');
  var fZip     = root.querySelector('input[name="attributes[Shipping ZIP]"]');
  var fCountry = root.querySelector('input[name="attributes[Shipping Country]"]');
  var fPlaceId = root.querySelector('input[name="attributes[Google Place ID]"]');
  var fFull    = root.querySelector('textarea[name="attributes[Shipping Address]"]');


  var v = {
    contact_name: fContact ? fContact.value : "",
    phone_number: fPhone ? fPhone.value : "",
    reference_number: fRef ? fRef.value : "",
    company_name: fCompany ? fCompany.value : "",

    shipping_address_search: fSearch ? fSearch.value : "",
    shipping_address_1: fAddr1 ? fAddr1.value : "",
    shipping_address_2: fAddr2 ? fAddr2.value : "",
    shipping_city: fCity ? fCity.value : "",
    shipping_state: fState ? fState.value : "",
    shipping_zip: fZip ? fZip.value : "",
    shipping_country: fCountry ? fCountry.value : "",
    google_place_id: fPlaceId ? fPlaceId.value : ""
  };

  v.shipping_address = buildFullShippingAddress(v);

if (fFull) {
  fFull.value = v.shipping_address;
}

return v;
}

    function syncShippingToCart() {
      var v = getFieldValues();
      return saveCartAttributes({
  "Shipping Contact Name": v.contact_name,
  "Shipping Phone": v.phone_number,
  "Reference Number": v.reference_number,
  "Company Name": v.company_name,

  "Shipping Address Search": v.shipping_address_search,
  "Shipping Address 1": v.shipping_address_1,
  "Shipping Address 2": v.shipping_address_2,
  "Shipping City": v.shipping_city,
  "Shipping State": v.shipping_state,
  "Shipping ZIP": v.shipping_zip,
  "Shipping Country": v.shipping_country,
  "Google Place ID": v.google_place_id,

  "Shipping Address": v.shipping_address
}).catch(function (err) {
        console.error("[ND AB] cart update error", err);
      });
    }

    function queueSync() {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        syncShippingToCart();
      }, 250);
    }

    function loadGoogleMapsPlacesScript() {
  return new Promise(function (resolve, reject) {
    if (window.google && window.google.maps && window.google.maps.importLibrary) {
      resolve();
      return;
    }

    var existing = document.getElementById(GOOGLE_MAPS_SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", function () {
        resolve();
      });
      existing.addEventListener("error", function () {
        reject(new Error("Google Maps script failed to load."));
      });
      return;
    }

    if (!GOOGLE_MAPS_API_KEY || GOOGLE_MAPS_API_KEY === "貼上你的 Google API Key") {
      reject(new Error("Google Maps API key is missing."));
      return;
    }

    var script = document.createElement("script");
    script.id = GOOGLE_MAPS_SCRIPT_ID;
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=" +
      encodeURIComponent(GOOGLE_MAPS_API_KEY) +
      "&v=weekly&loading=async&libraries=places";
    script.async = true;
    script.defer = true;

    script.onload = function () {
      resolve();
    };

    script.onerror = function () {
      reject(new Error("Google Maps script failed to load."));
    };

    document.head.appendChild(script);
  });
}

function getGoogleAddressComponentNew(place, type, useShortText) {
  var components = place && place.addressComponents ? place.addressComponents : [];

  for (var i = 0; i < components.length; i++) {
    var component = components[i];
    var types = component.types || [];

    if (types.indexOf(type) !== -1) {
      if (useShortText) {
        return component.shortText || component.longText || "";
      }
      return component.longText || component.shortText || "";
    }
  }

  return "";
}
function initGoogleAddressAutocomplete() {
  console.log("[ND Google Address] initGoogleAddressAutocomplete called");

  var fSearch = root.querySelector("#nd-google-address-search");

  if (!fSearch) {
    console.warn("[ND Google Address] #nd-google-address-search not found.");
    return;
  }

  if (root.querySelector("#nd-google-address-autocomplete-element")) {
    console.log("[ND Google Address] autocomplete already inserted.");
    return;
  }

  loadGoogleMapsPlacesScript()
    .then(function () {
      return window.google.maps.importLibrary("places");
    })
    .then(function (placesLibrary) {
      var PlaceAutocompleteElement =
        placesLibrary.PlaceAutocompleteElement ||
        window.google.maps.places.PlaceAutocompleteElement;

      if (!PlaceAutocompleteElement) {
        throw new Error("PlaceAutocompleteElement is not available.");
      }

      // 只調整 Google 搜尋框外觀；不包外層 div，避免影響預搜尋下拉結果
      if (!document.getElementById("nd-google-address-autocomplete-style")) {
        var style = document.createElement("style");
        style.id = "nd-google-address-autocomplete-style";
        style.textContent = [
          "#nd-google-address-autocomplete-element {",
          "  display: block;",
          "  width: 100%;",
          "  max-width: 100%;",
          "  margin-bottom: 10px;",
          "  box-sizing: border-box;",
          "  border: 0.8px solid rgb(153,153,153);",
          "  border-radius: 6px;",
          "  background: transparent;",
          "  min-height: 42px;",
          "  font-size: 1.4rem;",
          "  font-family: inherit;",
          "  color: inherit;",
          "  box-shadow: none;",
          "  overflow: visible;",
          "  transition: border-color .2s ease, box-shadow .2s ease;",
          "}",
          "#nd-google-address-autocomplete-element:focus-within {",
          "  border-color: #777;",
          "  box-shadow: 0 0 0 2px rgba(0,0,0,.06);",
          "}",
          "#nd-google-address-autocomplete-element::part(input) {",
          "  font-size: 1.4rem;",
          "  font-family: inherit;",
          "}",
          ""
        ].join("\n");
        document.head.appendChild(style);
      }

      // 跟你 Console 測試成功的寫法一致
      var placeAutocomplete = new PlaceAutocompleteElement();

      placeAutocomplete.id = "nd-google-address-autocomplete-element";
      placeAutocomplete.includedRegionCodes = ["us"];

      placeAutocomplete.style.display = "block";
      placeAutocomplete.style.width = "100%";
      placeAutocomplete.style.maxWidth = "100%";
      placeAutocomplete.style.marginBottom = "10px";
      placeAutocomplete.style.boxSizing = "border-box";
      placeAutocomplete.style.border = "0.8px solid rgb(153,153,153)";
      placeAutocomplete.style.borderRadius = "6px";
      placeAutocomplete.style.backgroundColor = "transparent";
      placeAutocomplete.style.minHeight = "42px";
      placeAutocomplete.style.fontSize = INPUT_FONT_SIZE;
      placeAutocomplete.style.fontFamily = "inherit";
      placeAutocomplete.style.color = "inherit";
      placeAutocomplete.style.boxShadow = "none";
      placeAutocomplete.style.overflow = "visible";

      try {
        placeAutocomplete.placeholder = "Start typing shipping address...";
      } catch (e) {}

      // 隱藏原本普通 input，改用 Google 新元件
      fSearch.style.display = "none";
      fSearch.insertAdjacentElement("afterend", placeAutocomplete);

      console.log("[ND Google Address] styled PlaceAutocompleteElement inserted", placeAutocomplete);

      async function handlePlaceSelect(event) {
        try {
          console.log("[ND Google Address] selected event =", event);

          var placePrediction =
            event.placePrediction ||
            (event.detail && event.detail.placePrediction);

          if (!placePrediction) {
            console.warn("[ND Google Address] No placePrediction found.", event);
            return;
          }

          var place = placePrediction.toPlace();

          await place.fetchFields({
            fields: ["id", "formattedAddress", "addressComponents"]
          });

          var streetNumber = getGoogleAddressComponentNew(place, "street_number", false);
          var route = getGoogleAddressComponentNew(place, "route", false);
          var subpremise = getGoogleAddressComponentNew(place, "subpremise", false);

          var city =
            getGoogleAddressComponentNew(place, "locality", false) ||
            getGoogleAddressComponentNew(place, "postal_town", false) ||
            getGoogleAddressComponentNew(place, "sublocality_level_1", false) ||
            getGoogleAddressComponentNew(place, "administrative_area_level_3", false) ||
            getGoogleAddressComponentNew(place, "administrative_area_level_2", false);

          var state = getGoogleAddressComponentNew(place, "administrative_area_level_1", true);
          var zip = getGoogleAddressComponentNew(place, "postal_code", false);
          var zipSuffix = getGoogleAddressComponentNew(place, "postal_code_suffix", false);
          var country = getGoogleAddressComponentNew(place, "country", false) || "United States";

          if (zip && zipSuffix) {
            zip = zip + "-" + zipSuffix;
          }

          var addr1 = [streetNumber, route].filter(Boolean).join(" ");

          var fAddr1 = root.querySelector('input[name="attributes[Shipping Address 1]"]');
          var fAddr2 = root.querySelector('input[name="attributes[Shipping Address 2]"]');
          var fCity = root.querySelector('input[name="attributes[Shipping City]"]');
          var fState = root.querySelector('select[name="attributes[Shipping State]"]');
          var fZip = root.querySelector('input[name="attributes[Shipping ZIP]"]');
          var fCountry = root.querySelector('input[name="attributes[Shipping Country]"]');
          var fPlaceId = root.querySelector('input[name="attributes[Google Place ID]"]');
          var fFull = root.querySelector('textarea[name="attributes[Shipping Address]"]');

          if (fSearch) fSearch.value = place.formattedAddress || addr1;
          if (fAddr1) fAddr1.value = addr1;
          if (fAddr2 && !fAddr2.value && subpremise) fAddr2.value = subpremise;
          if (fCity) fCity.value = city;
          if (fState) fState.value = String(state || "").toUpperCase();
          if (fZip) fZip.value = zip;
          if (fCountry) fCountry.value = country;
          if (fPlaceId) fPlaceId.value = place.id || "";

          var fullAddress = [
            addr1,
            fAddr2 ? fAddr2.value : "",
            [city, String(state || "").toUpperCase(), zip].filter(Boolean).join(", "),
            country
          ].filter(Boolean).join("\n");

          if (fFull) fFull.value = fullAddress;

          queueSync();
        } catch (err) {
          console.error("[ND Google Address] select error", err);
          setMsg("Failed to apply selected address.", true);
        }
      }

      placeAutocomplete.addEventListener("gmp-select", handlePlaceSelect);
      placeAutocomplete.addEventListener("gmp-placeselect", handlePlaceSelect);
    })
    .catch(function (err) {
  console.error("[ND Google Address]", err);
});
}

   function applyAddress(item) {
  var fContactNow = root.querySelector('input[name="attributes[Shipping Contact Name]"]');
  var fPhoneNow   = root.querySelector('input[name="attributes[Shipping Phone]"]');
  var fRefNow     = root.querySelector('input[name="attributes[Reference Number]"]');
  var fCompanyNow = root.querySelector('input[name="attributes[Company Name]"]');

  var fSearchNow  = root.querySelector('#nd-google-address-search');
  var fAddr1Now   = root.querySelector('input[name="attributes[Shipping Address 1]"]');
  var fAddr2Now   = root.querySelector('input[name="attributes[Shipping Address 2]"]');
  var fCityNow    = root.querySelector('input[name="attributes[Shipping City]"]');
  var fStateNow   = root.querySelector('select[name="attributes[Shipping State]"]');
  var fZipNow     = root.querySelector('input[name="attributes[Shipping ZIP]"]');
  var fCountryNow = root.querySelector('input[name="attributes[Shipping Country]"]');
  var fPlaceIdNow = root.querySelector('input[name="attributes[Google Place ID]"]');
  var fFullNow    = root.querySelector('textarea[name="attributes[Shipping Address]"]');

  var contact = item.contact_name || item.contact || "";
  var phone   = item.phone_number || item.phone || "";
  var company = item.company_name || item.company || "";
  var refNo   = item.reference_number || item.reference_no || item.reference || "";

  var addr1   = item.shipping_address_1 || item.address_1 || item.address1 || item.shipping_address || item.address || "";
  var addr2   = item.shipping_address_2 || item.address_2 || item.address2 || "";
  var city    = item.shipping_city || item.city || "";
  var state   = item.shipping_state || item.state || item.shippingState || item["Shipping State"] || "";
  var zip     = item.shipping_zip || item.zip || item.zip_code || item.postal_code || "";
  var country = item.shipping_country || item.country || "United States";
  var placeId = item.google_place_id || item.place_id || "";

  var fullAddress = [
    addr1,
    addr2,
    [city, String(state || "").toUpperCase(), zip].filter(Boolean).join(", "),
    country
  ].filter(Boolean).join("\n");

  if (fContactNow) fContactNow.value = contact;
  if (fPhoneNow)   fPhoneNow.value   = phone;
  if (fCompanyNow) fCompanyNow.value = company;

  if (fSearchNow)  fSearchNow.value  = item.shipping_address_search || "";
  if (fAddr1Now)   fAddr1Now.value   = addr1;
  if (fAddr2Now)   fAddr2Now.value   = addr2;
  if (fCityNow)    fCityNow.value    = city;
  if (fStateNow)   fStateNow.value   = String(state || "").toUpperCase();
  if (fZipNow)     fZipNow.value     = zip;
  if (fCountryNow) fCountryNow.value = country;
  if (fPlaceIdNow) fPlaceIdNow.value = placeId;
  if (fFullNow)    fFullNow.value    = fullAddress;

  if (SAVE_REFERENCE_NUMBER_TO_ADDRESS_BOOK && fRefNow) {
    fRefNow.value = refNo;
  }

  queueSync();
}

    function clearShippingFields() {
  var fContactNow = root.querySelector('input[name="attributes[Shipping Contact Name]"]');
  var fPhoneNow   = root.querySelector('input[name="attributes[Shipping Phone]"]');
  var fRefNow     = root.querySelector('input[name="attributes[Reference Number]"]');
  var fCompanyNow = root.querySelector('input[name="attributes[Company Name]"]');

  var fSearchNow  = root.querySelector('#nd-google-address-search');
  var fAddr1Now   = root.querySelector('input[name="attributes[Shipping Address 1]"]');
  var fAddr2Now   = root.querySelector('input[name="attributes[Shipping Address 2]"]');
  var fCityNow    = root.querySelector('input[name="attributes[Shipping City]"]');
  var fStateNow   = root.querySelector('select[name="attributes[Shipping State]"]');
  var fZipNow     = root.querySelector('input[name="attributes[Shipping ZIP]"]');
  var fCountryNow = root.querySelector('input[name="attributes[Shipping Country]"]');
  var fPlaceIdNow = root.querySelector('input[name="attributes[Google Place ID]"]');
  var fFullNow    = root.querySelector('textarea[name="attributes[Shipping Address]"]');

  if (fContactNow) fContactNow.value = "";
  if (fPhoneNow)   fPhoneNow.value   = "";
  if (fRefNow)     fRefNow.value     = "";
  if (fCompanyNow) fCompanyNow.value = "";

  if (fSearchNow)  fSearchNow.value  = "";
  if (fAddr1Now)   fAddr1Now.value   = "";
  if (fAddr2Now)   fAddr2Now.value   = "";
  if (fCityNow)    fCityNow.value    = "";
  if (fStateNow)   fStateNow.value   = "";
  if (fZipNow)     fZipNow.value     = "";
  if (fCountryNow) fCountryNow.value = "United States";
  if (fPlaceIdNow) fPlaceIdNow.value = "";
  if (fFullNow)    fFullNow.value    = "";

  queueSync();
  setMsg("Shipping info cleared.", false);
}

    function reloadList() {
      if (!customerEmail) {
        selectEl.disabled  = true;
        btnSave.disabled   = true;
        btnDelete.disabled = true;
        btnClear.disabled  = false;
        setMsg("Please sign in to use Address Book.", false);
        return;
      }

      if (!apiUrl || !apiKey || /PUT_YOUR_NEW_/.test(apiUrl) || /PUT_YOUR_NEW_/.test(apiKey)) {
        setMsg("Address Book API is not configured.", true);
        return;
      }

      selectEl.disabled  = false;
      btnSave.disabled   = false;
      btnDelete.disabled = false;
      btnClear.disabled  = false;

      setMsg("Loading saved addresses...", false);

      fetchJSON({
        action: "listAddressBook",
        key: apiKey,
        customer_email: customerEmail
      })
        .then(function (data) {
          console.log("[ND AB] listAddressBook data =", data);

          if (!data || data.ok === false) {
            var err = (data && data.error) ? data.error : "Unknown error";
            setMsg("Failed to load: " + err, true);
            return;
          }

          itemsCache = data.items || [];

          while (selectEl.firstChild) {
            selectEl.removeChild(selectEl.firstChild);
          }

          var opt0 = document.createElement("option");
          opt0.value = "";
          opt0.textContent = "-- Select saved info --";
          selectEl.appendChild(opt0);

          itemsCache.forEach(function (it) {
            var opt = document.createElement("option");
            opt.value = it.id || "";
            opt.textContent = it.label || it.shipping_address || "(no label)";
            selectEl.appendChild(opt);
          });

          if (!itemsCache.length) {
            setMsg("No saved addresses yet.", false);
          } else {
            setMsg("", false);
          }
        })
        .catch(function (err) {
          console.error("[ND AB] list error", err);
          setMsg("Failed to load addresses.", true);
        });
    }

    function loadById(id, showMessage) {
      if (!id) {
        if (showMessage) setMsg("Please select an address first.", true);
        return;
      }

      var item = itemsCache.find(function (it) {
        return String(it.id || "") === String(id);
      });

      if (!item) {
        if (showMessage) setMsg("Saved info not found.", true);
        return;
      }

      applyAddress(item);

      if (showMessage) {
        setMsg("Address loaded.", false);
      }
    }

    selectEl.addEventListener("change", function () {
      loadById(selectEl.value, false);
    });

    btnSave.addEventListener("click", function () {
      if (!customerEmail) {
        setMsg("Please sign in before saving.", true);
        return;
      }

      var label = window.prompt(
        "Name for this address (for example: Home / Office):",
        ""
      );
      if (label === null) return;
      label = String(label || "").trim();

      if (!label) {
        setMsg("Label is required.", true);
        return;
      }

      var v = getFieldValues();

      var params = {
  action: "saveAddress",
  key: apiKey,
  customer_email: customerEmail,
  label: label,

  contact_name: v.contact_name,
  phone_number: v.phone_number,
  company_name: v.company_name,

  shipping_address_search: v.shipping_address_search,
  shipping_address: v.shipping_address,
  shipping_address_1: v.shipping_address_1,
  shipping_address_2: v.shipping_address_2,
  shipping_city: v.shipping_city,
  shipping_state: v.shipping_state,
  shipping_zip: v.shipping_zip,
  shipping_country: v.shipping_country,
  google_place_id: v.google_place_id
};

      if (SAVE_REFERENCE_NUMBER_TO_ADDRESS_BOOK) {
        params.reference_number = v.reference_number;
      }

      setMsg("Saving address...", false);

      syncShippingToCart()
        .then(function () {
          return fetchJSON(params);
        })
        .then(function (data) {
          if (!data || data.ok === false) {
            var err = (data && data.error) ? data.error : "Unknown error";
            setMsg("Save failed: " + err, true);
            return;
          }
          setMsg("Address saved.", false);
          reloadList();
        })
        .catch(function (err) {
          console.error("[ND AB] save error", err);
          setMsg("Save failed.", true);
        });
    });

    btnDelete.addEventListener("click", function () {
      if (!customerEmail) {
        setMsg("Please sign in before deleting.", true);
        return;
      }

      var id = selectEl.value;
      if (!id) {
        setMsg("Please select an address to delete.", true);
        return;
      }

      var ok = window.confirm("Delete this address?");
      if (!ok) return;

      var params = {
        action: "deleteAddress",
        key: apiKey,
        customer_email: customerEmail,
        id: id
      };

      setMsg("Deleting address...", false);

      fetchJSON(params)
        .then(function (data) {
          if (!data || data.ok === false) {
            var err = (data && data.error) ? data.error : "Unknown error";
            setMsg("Delete failed: " + err, true);
            return;
          }
          setMsg("Address deleted.", false);
          reloadList();
        })
        .catch(function (err) {
          console.error("[ND AB] delete error", err);
          setMsg("Delete failed.", true);
        });
    });

    btnClear.addEventListener("click", function () {
      clearShippingFields();
    });

    [
  '#nd-google-address-search',
  'input[name="attributes[Shipping Contact Name]"]',
  'input[name="attributes[Shipping Phone]"]',
  'input[name="attributes[Reference Number]"]',
  'input[name="attributes[Company Name]"]',

  'input[name="attributes[Shipping Address 1]"]',
  'input[name="attributes[Shipping Address 2]"]',
  'input[name="attributes[Shipping City]"]',
  'select[name="attributes[Shipping State]"]',
  'input[name="attributes[Shipping ZIP]"]',
  'input[name="attributes[Shipping Country]"]',
  'input[name="attributes[Google Place ID]"]',
  'textarea[name="attributes[Shipping Address]"]'
].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (!el) return;
      el.addEventListener("change", queueSync);
      el.addEventListener("blur", queueSync);
    });

   initGoogleAddressAutocomplete();
setTimeout(initGoogleAddressAutocomplete, 500);
setTimeout(initGoogleAddressAutocomplete, 1500);
reloadList();
  }

    async function cartHasItems() {
    try {
      var res = await fetch("/cart.js", {
        method: "GET",
        headers: { "Accept": "application/json" },
        credentials: "same-origin"
      });
      var cart = await res.json();
      return !!(cart && Number(cart.item_count) > 0);
    } catch (err) {
      console.error("[ND Shipping] failed to read /cart.js", err);

      // fallback：如果抓不到 cart.js，就用 DOM 粗略判斷
      return !!document.querySelector(
        'input[name="updates[]"], .cart-item, .cart-items tbody tr, [data-cart-item]'
      );
    }
  }

  // ---------- Init on /cart page ----------

    async function init() {
  if (!/\/cart(\/|$)/.test(location.pathname)) return;

  var form = getCartForm();
  if (!form) return;

  var hasItems = await cartHasItems();

  // 先清理重複的舊 block
  removeDuplicateShippingBlocks();

  var existing = document.getElementById("nd-cart-shipping-fields");

  // 購物車空的：不要顯示，若已存在也移除
  if (!hasItems) {
    if (existing) existing.remove();
    return;
  }

  // 已存在就不要重建，只保留一份
  if (existing) return;

  var freshAttrs = await fetchFreshCartAttrs();
var block = buildAddressBookAndShippingBlock(freshAttrs);

  // 優先插在 main cart items 前面，避免插到奇怪的 form/container
  var host = getMainCartHost();

  if (host && host.parentNode) {
    host.parentNode.insertBefore(block, host);
  } else if (form && form.parentNode) {
    form.parentNode.insertBefore(block, form);
  } else {
    document.body.appendChild(block);
  }

  setupAddressBook(block);

  // 再保險清一次，只留第一份
  removeDuplicateShippingBlocks();
}

  function watchCartChanges() {
    var ticking = false;

    function rerun() {
      if (ticking) return;
      ticking = true;

      setTimeout(function () {
        ticking = false;
        init();
      }, 150);
    }

    document.addEventListener("click", function (e) {
      var btn = e.target.closest('button, a');
      if (!btn) return;

      var txt = (btn.textContent || btn.innerText || "").toLowerCase();

      if (
        txt.indexOf("remove") !== -1 ||
        btn.matches('[href*="/cart/change"], [data-cart-remove], .cart-remove-button')
      ) {
        rerun();
      }
    });

    document.addEventListener("change", function (e) {
      var el = e.target;
      if (!el) return;

      if (
        el.matches('input[name="updates[]"], .quantity__input, [data-quantity-input]')
      ) {
        rerun();
      }
    });

    var obs = new MutationObserver(function () {
      rerun();
    });

    obs.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

    if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
      watchCartChanges();
    });
  } else {
    init();
    watchCartChanges();
  }
})();
